import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from '../pages/auth-pages/login-page';

const PublicRoutes = ({ auth }) => {
    return !auth && (
        <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/*" element={<Navigate to="/login" />} />
        </Routes>
    );
};

export default PublicRoutes;
